import React, { useState, useEffect, useRef } from "react";
import './navbar.css';
import logo from '../../assets/justin.png';
import contactImg from '../../assets/contact.png';
import { Link } from 'react-scroll';
import menu from '../../assets/menu.png';

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const navMenuRef = useRef(null);

    const click = () => {
        window.open('https://api.whatsapp.com/send/?phone=6287839155633&text&type=phone_number&app_absent=0', '_blank');
        setShowMenu(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navMenuRef.current && !navMenuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        if (showMenu) document.addEventListener('mousedown', handleClickOutside);
        else document.removeEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMenu]);

    return (
        <>
            <div
                className={`menuOverlay ${showMenu ? 'show' : ''}`}
                onClick={() => setShowMenu(false)}
            ></div>

            <nav className="navbar">
                <img src={logo} alt="Logo" className="logo" />
                <div className="desktopMenu">
                    <Link to='intro' smooth offset={-100} duration={500} className="desktopMenuListItem">Home</Link>
                    <Link to='skills' smooth offset={-50} duration={500} className="desktopMenuListItem">Skills</Link>
                    <Link to='galeri' smooth offset={-50} duration={500} className="desktopMenuListItem">Gallery</Link>
                    <Link to='contactPage' smooth offset={-50} duration={500} className="desktopMenuListItem">Service</Link>
                </div>

                <a
                    href="https://api.whatsapp.com/send/?phone=6287839155633&text&type=phone_number&app_absent=0"
                    rel="noreferrer"
                    target="_blank"
                >
                    <button className="desktopMenuBtn">
                        <img src={contactImg} alt="" className="desktopMenuImg" />WhatsApp
                    </button>
                </a>

                <img
                    src={menu}
                    alt="Menu"
                    className="mobMenu"
                    onClick={() => setShowMenu(!showMenu)}
                />

                <div
                    ref={navMenuRef}
                    className={`navMenu ${showMenu ? 'open' : ''}`}
                >
                    <Link to='intro' smooth offset={-100} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Home</Link>
                    <Link to='skills' smooth offset={-50} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Skill</Link>
                    <Link to='galeri' smooth offset={-50} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Galeri</Link>
                    <Link to='contactPage' smooth offset={-50} duration={500} className="listItem" onClick={() => setShowMenu(false)}>Layanan</Link>
                    <Link to='contact' smooth offset={-50} duration={500} className="listItem" onClick={click}>Contact</Link>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
